import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import classNames from "classnames";
import * as WebUtils from "utils/WebUtils";
import { compose } from "utils/WebUtils";
import { withStyles } from "@material-ui/core/styles";
import { withCookies } from "react-cookie";
import withWidth, { isWidthDown, isWidthUp } from "@material-ui/core/withWidth";
import { LinearProgress, Typography, Button, Divider } from "@material-ui/core";
import Sidenav from "layouts/components/sidenav/sidenav.component";
import MstrLogout from "containers/reports/MstrLogout";
import {
    currentOrganization,
    currentUser,
    userOrganizations
} from "redux/selectors/user.selector";
import { markSeenACTour } from "utils/Crisp";
import EntitySelectors from "redux/selectors";

// Actions
import {
    setSidenavOpen,
    setContentFullWidth,
    toggleSidenav,
    toggleSidenavVariant
} from "redux/actions/layout.actions";

import scss from "./layout-compact.module.scss";
import styles from "./layout-compact.style";
import TourWindow from "../../components/Tour/TourWindow";
import WelcomeTour from "../../components/Tour/WelcomeTour";
import Notification from "../../containers/Notification";
import UpgradeSplashDialog from "../../components/UpgradeSplash";
import {
    autoSync,
    getClientSSPFields,
    joyRide,
    showImportDialog,
    showQuickViewBanner,
    showUpgradeDialog,
    showSuspendedBanner,
    triggerTour,
    joyRideData,
    currentJoyRide,
    getOrgConfigurations
} from "redux/selectors/data.selector";

import { setData2, unset2 } from "redux/actions/data.actions";
import Joyride, { EVENTS } from "react-joyride";

import { allTours } from "../../components/Tour/JoyRideConfig";
import Alert from "@material-ui/lab/Alert/Alert";
import { getPlan, getTrial } from "utils/auth";
import IntegrationSyncForm from "containers/sync/sync-search/IntegrationSyncForm";
import { withRouter } from "react-router-dom";
import {
    updateOrganizationAttribute,
    getIncorrectJournalAccountMappings,
    displayCopilot,
    resolveChargebeeRegion
} from "rest/API";

import { RateReview, Settings } from "@material-ui/icons";
import PLG from "./PLG";
import ReportsMigrationModal from "containers/reports/migration-notice/ReportsMigrationModal";
import { SecurityUtils } from "revlock-webutils";
import ExtendTenantExpire from "../../components/ExtendTenantExpire";
import MigrateToChargebeeSignIn from "../../components/MigrateToChargebeeSignIn";
import config from "cfg/config";
const WIDGET_BASE_URL = config.copilotWidgetUrl;

const notificationSelectors = EntitySelectors.notification;

class CompactLayout extends React.Component {
    // Set the initial layout state when the layout is initialised
    constructor(props) {
        super(props);
        const variant = isWidthDown("sm", props.width)
            ? "temporary"
            : "persistent";
        props.toggleSidenavVariant(variant);
        props.setSidenavOpen(variant === "persistent");
        this.state = {
            showSuspenededBanner: false,
            showIncorrectJAMBanner: false,
            run: true
        };
    }

    async componentDidUpdate(prevProps, prevState) {
        const { currentUser, currentOrganization } = this.props;

        // Handle organization change - ensures logic runs when user switches orgs
        const orgIdChanged =
            prevProps.currentOrganization?.id !==
            this.props.currentOrganization?.id;

        const attachCopilot = async () => {
            try {
                const org = this.props.currentOrganization;
                const orgId = org?.id;
                const chargebeeSite = org?.chargebeeSite;
                const merchantId = org?.merchantId;
                if (!orgId || !chargebeeSite) return;

                const stillCurrent = () =>
                    this.props.currentOrganization?.id === orgId;

                const isCopilotEnabled = await displayCopilot(merchantId);
                if (!isCopilotEnabled || !stillCurrent()) return;

                let chargebeeRegion = org.chargebeeRegion;
                if (!chargebeeRegion) {
                    try {
                        const result = await resolveChargebeeRegion(orgId);
                        if (!stillCurrent()) return;
                        chargebeeRegion = result?.region;
                        if (chargebeeRegion) {
                            this.props.patchOrganization({
                                ...this.props.currentOrganization,
                                chargebeeRegion
                            });
                        }
                    } catch (error) {
                        console.error(
                            "Failed to resolve chargebee region:",
                            error
                        );
                        if (!stillCurrent()) return;
                    }
                }

                if (!chargebeeRegion) return;

                const copilotScript = document.createElement("script");
                copilotScript.setAttribute("src", `${WIDGET_BASE_URL}`);
                copilotScript.setAttribute("async", "true");
                const widgetContainer = document.getElementById(
                    "copilot-widget-container"
                );

                copilotScript.onload = () => {
                    if (!stillCurrent()) return;
                    window.ChargebeeCopilot?.mount({
                        container: widgetContainer,
                        product: "revrec",
                        region: chargebeeRegion,
                        site: chargebeeSite
                    });
                };

                if (this.props.currentOrganization?.chargebeeSite) {
                    document.head.appendChild(copilotScript);
                }
            } catch (error) {
                console.error("Error in attachCopilot:", error);
            }
        };

        if (currentUser && this.props.currentOrganization && orgIdChanged) {
            attachCopilot();
        }
    }

    setJoyrideCallback = (data) => {
        const { currentJoyRide, currentOrganization, isACSite } = this.props;
        const productSpace = window.location.pathname.startsWith("/ac/")
            ? "ac"
            : "revrec";
        if (data && currentJoyRide && isACSite) {
            const {
                action,
                index,
                step: {
                    data: { next, previous }
                },
                type
            } = data;
            const isPreviousAction = action === "prev";

            if (
                type === EVENTS.STEP_AFTER &&
                (action != "update" || index == 0)
            ) {
                if (action == "close") {
                    setData2("currentJoyRide", "");
                    setData2("joyRideData", { run: false });
                    markSeenACTour(currentOrganization.id, undefined, history);
                    return;
                }

                if (index < 7) {
                    setData2("joyRideData", { run: false });
                    this.props.history.push(
                        isPreviousAction && previous
                            ? `/ac/${currentOrganization.id}/${previous}`
                            : `/ac/${currentOrganization.id}/${next}`
                    );
                } else {
                    if (isPreviousAction && previous) {
                        setData2("joyRideData", { run: false });
                        this.props.history.push(
                            `/ac/${currentOrganization.id}/${previous}`
                        );
                    } else {
                        setData2("currentJoyRide", "");
                        setData2("joyRideData", { run: false });
                        markSeenACTour(
                            currentOrganization.id,
                            undefined,
                            history
                        );
                    }
                }
            }
        } else if (productSpace == "revrec") {
            const { type, status } = data;

            if (type == "tour:end" && status == "finished")
                setData2("currentJoyRide", null);
        }
    };

    setJoyrideHelpers = (helpers) => {
        this.joyRideHelpers = helpers;
    };

    async fetchIncorrectJournalAccountMappings() {
        const { currentOrganization, checkIncorrectJAMMappings, isACSite } =
            this.props;
        const { alreadyMadeIncorrectJAMCall } = this.state;

        if (window.location.pathname.startsWith("/ac/")) {
            return;
        }

        if (
            currentOrganization &&
            (!alreadyMadeIncorrectJAMCall || checkIncorrectJAMMappings)
        ) {
            this.setState(
                {
                    alreadyMadeIncorrectJAMCall: true
                },
                () => {
                    unset2("checkIncorrectJAMMappings");
                }
            );
            const res = await getIncorrectJournalAccountMappings(
                currentOrganization.id
            );

            this.setState({
                showIncorrectJAMBanner: (res && res.result?.length) || false
            });
        }
    }

    componentDidMount() {
        if (this.props.currentOrganization) {
            setData2("checkIncorrectJAMMappings", true);
        }
    }

    // Update the layout state when a going from mobile to desktop and vice versa
    componentWillReceiveProps(nextProps) {
        if (
            isWidthDown("sm", this.props.width) &&
            isWidthUp("md", nextProps.width)
        ) {
            this.props.toggleSidenavVariant("persistent");
            this.props.setSidenavOpen(true);
        } else if (
            isWidthDown("sm", nextProps.width) &&
            isWidthUp("md", this.props.width)
        ) {
            this.props.toggleSidenavVariant("temporary");
            this.props.setSidenavOpen(false);
        }

        if (this.props.joyRide !== nextProps.joyRide)
            this.joyRideHelpers &&
                this.joyRideHelpers.reset &&
                this.joyRideHelpers.reset(true);

        if (this.props.currentOrganization != nextProps.currentOrganization) {
            this.setState({
                showSuspenededBanner:
                    nextProps.currentOrganization?.suspended === true ||
                    nextProps.currentOrganization?.suspended === 1 ||
                    false,
                alreadyMadeIncorrectJAMCall: false,
                showIncorrectJAMBanner: false
            });
        }

        if (this.props.currentOrganization) {
            this.fetchIncorrectJournalAccountMappings();
        }
    }

    handleHideAlert = async (e) => {
        e.stopPropagation();
        const { currentOrganization, patchOrganization, classes } = this.props;
        if (
            (currentOrganization.currentPeriod == undefined || null) &&
            currentOrganization.setupIncomplete
        ) {
            WebUtils.showAlert({
                content: (
                    <Typography variant={"body1"}>
                        {
                            "To get out of setup / restatement mode you must close your first accounting period. "
                        }
                        <a
                            href="https://www.chargebee.com/docs/revrec/journal-account-mapping.html"
                            target="_blank"
                            className={classes.linkCss}>
                            {"Learn How"}
                        </a>
                    </Typography>
                ),
                title: "",
                icon: "warning"
            });
        } else {
            setData2("showUpgradeDialog", null);
            const org = await updateOrganizationAttribute(
                currentOrganization.id,
                { setupIncomplete: false }
            );
            patchOrganization(org);
        }
    };

    handleAlertClick = async (e, isTrial) => {
        e.stopPropagation();
        if (isTrial) setData2("showUpgradeDialog", "plan");
    };

    render() {
        const {
            children,
            classes,
            showUpgradeDialog,
            showQuickViewBanner,
            showSuspendedBanner,
            showImportDialog,
            autoSync,
            sspFields,
            history,
            match,
            cookies,
            joyRideData,
            isACSite,
            skipIncorrectMappings,
            ...rest
        } = this.props;
        const {
            triggerTour,
            joyRide,
            userOrganizations,
            currentOrganization,
            steps,
            currentUser
        } = rest;
        const appModeResponse = cookies.get("appModeResponse");
        if (
            !userOrganizations ||
            !userOrganizations.length ||
            !currentOrganization
        )
            return <LinearProgress />;

        const activePlan = getPlan();
        const { isTrial, daysRemaining } = activePlan;
        const setupIncomplete =
            currentOrganization && currentOrganization.setupIncomplete;

        const revEssential =
            (currentOrganization &&
                currentOrganization.license &&
                currentOrganization.license.name === "rev-essential") ||
            false;

        const superAdminLevel = SecurityUtils.getSuperAdminLevel(currentUser);
        const disableActionsForQuickView =
            revEssential && superAdminLevel < SecurityUtils.SUPER_ADMIN_LEVEL_1;

        // Show dialog and banner if no tour being displayed and no upgrade popup is being displayed.
        const showPlg =
            !(!!showUpgradeDialog || showQuickViewBanner) && !triggerTour;

        const showExtendTenantDialog =
            (currentOrganization &&
                currentOrganization.license &&
                currentOrganization.license.showExtendTrialDailog) ||
            false;

        const migrateToChargebeeSignIn = currentUser.migrateToChargebeeSignIn;
        const isRevRecSpace =
            window.location.pathname.startsWith("/ac/") || isACSite
                ? false
                : true;
        return (
            <div
                className={classNames(
                    scss["layout-compact-wrapper"],
                    classes.wrapper
                )}>
                <Sidenav {...rest}></Sidenav>
                <main id="main-layout" className={scss["layout-compact-main"]}>
                    {isTrial && (
                        <Alert
                            classes={{
                                root: classes.warning,
                                message: classes.alertMessage
                            }}
                            severity="warning"
                            onClick={(e) => this.handleAlertClick(e, isTrial)}>
                            <div
                                style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center"
                                }}>
                                {isTrial && (
                                    <span>
                                        You have {daysRemaining} days left in
                                        your trial
                                    </span>
                                )}
                            </div>
                        </Alert>
                    )}
                    {this.state.showIncorrectJAMBanner &&
                        this.props.productSpace === "revrec" &&
                        !skipIncorrectMappings &&
                        !isACSite && (
                            <>
                                {isTrial && <Divider />}
                                <Alert
                                    onClick={(e) => {}}
                                    icon={
                                        <RateReview style={{ color: "grey" }} />
                                    }
                                    severity="warning"
                                    classes={{ root: classes.warning }}>
                                    We have found incorrect Journal Account
                                    mappings in the system. Please review and
                                    correct them for smooth accounting close
                                    process.{" "}
                                    <Button
                                        size="small"
                                        variant="outlined"
                                        onClick={() =>
                                            this.props?.history.push(
                                                `/${currentOrganization.id}/journalaccounts?incorrectmappings=true`
                                            )
                                        }
                                        style={{
                                            borderColor: "#d32f2f",
                                            color: "#d32f2f",
                                            marginLeft: "8px"
                                        }}>
                                        Review
                                    </Button>
                                </Alert>
                            </>
                        )}
                    {appModeResponse && appModeResponse.mode == "r" && (
                        <Alert
                            icon={<Settings style={{ color: "grey" }} />}
                            severity="info"
                            classes={{ root: classes.info }}>
                            All modifications to data are currently disabled due
                            to scheduled system maintenance. Please try again
                            later.
                        </Alert>
                    )}

                    {showPlg && (
                        <PLG
                            currentOrganization={currentOrganization}
                            currentUser={currentUser}
                        />
                    )}

                    <ReportsMigrationModal />

                    <div className={scss["layout-compact-content-wrapper"]}>
                        <div
                            className={classNames(
                                scss["layout-compact-content"],
                                this.props.contentFullWidth &&
                                    scss["layout-compact-content-full-width"]
                            )}>
                            <Notification />
                            {children}
                        </div>
                    </div>
                    <div id="copilot-widget-container" />
                </main>

                {disableActionsForQuickView ? (
                    <WelcomeTour open={triggerTour} />
                ) : (
                    <TourWindow open={triggerTour} />
                )}
                <UpgradeSplashDialog
                    open={
                        !!showUpgradeDialog ||
                        showQuickViewBanner ||
                        showSuspendedBanner
                    }
                    type={showUpgradeDialog}
                    onClose={() => {
                        setData2("showUpgradeDialog", null);
                        setData2("showQuickViewBanner", null);
                        setData2("showSuspendedBanner", null);
                    }}
                />

                {showExtendTenantDialog && (
                    <ExtendTenantExpire
                        currentOrganization={currentOrganization}
                    />
                )}
                {migrateToChargebeeSignIn && (
                    <MigrateToChargebeeSignIn
                        currentOrganization={currentOrganization}
                    />
                )}

                <Joyride
                    callback={this.setJoyrideCallback}
                    getHelpers={this.setJoyrideHelpers}
                    continuous={true}
                    run={
                        isRevRecSpace
                            ? joyRide
                            : (joyRideData && joyRideData.run) || false
                    }
                    steps={steps}
                    stepIndex={
                        isRevRecSpace
                            ? null
                            : (joyRideData && joyRideData.stepIndex) || 0
                    }
                    scrollToFirstStep={true}
                    showProgress={true}
                    // showSkipButton={true}
                    styles={{
                        options: {
                            primaryColor: "#012a38"
                        }
                    }}
                />
                <IntegrationSyncForm
                    visible={showImportDialog}
                    autoSync={autoSync}
                    onClose={() => setData2("showImportDialog", null)}
                    user={currentUser}
                />
                <MstrLogout />
            </div>
        );
    }
}

function mapStateToProps(state, props) {
    const currentRide = joyRide(state);
    const orgConfigs = getOrgConfigurations(state);
    const siteConfig =
        orgConfigs && orgConfigs.find((oc) => oc.id == "site/type");
    const isACSite = (siteConfig && siteConfig.value == "ac") || false;

    const skipIncorrectMappingsConfig =
        orgConfigs &&
        orgConfigs.find(
            (e) => e.id === "properties/incorrect-journal-mappings/disabled"
        );
    const skipIncorrectMappings = skipIncorrectMappingsConfig?.value === true;

    const toReturn = {
        layout: {
            sidenavOpen: state.layout.sidenavOpen
        },
        contentFullWidth: state.layout.contentFullWidth,
        triggerTour: triggerTour(state),
        organizations: userOrganizations(state),
        currentOrganization: currentOrganization(state),
        userOrganizations: userOrganizations(state),
        currentUser: currentUser(state),
        notification: notificationSelectors.selectAll(state),
        showUpgradeDialog: showUpgradeDialog(state),
        showQuickViewBanner: showQuickViewBanner(state),
        showSuspendedBanner: showSuspendedBanner(state),
        showImportDialog: showImportDialog(state),
        autoSync: autoSync(state),
        joyRide: !!currentRide,
        sspFields: getClientSSPFields(state),
        checkIncorrectJAMMappings: state.data?.checkIncorrectJAMMappings,
        productSpace: state.data.productSpace || "revrec",
        joyRideData: joyRideData(state),
        currentJoyRide: currentJoyRide(state),
        isACSite,
        skipIncorrectMappings
    };

    if (currentRide) {
        const tour = allTours[currentRide];
        if (tour && tour.steps) {
            toReturn.steps = tour.steps;
            toReturn.currentRide = currentRide;
        }
    }

    return toReturn;
}

CompactLayout.propTypes = {
    classes: PropTypes.shape({}).isRequired,
    children: PropTypes.shape({}).isRequired,
    width: PropTypes.string.isRequired,
    toggleSidenavVariant: PropTypes.func.isRequired,
    setSidenavOpen: PropTypes.func.isRequired
};

export default compose(
    withRouter,
    withCookies,
    withWidth(),
    withStyles(styles, { withTheme: true }),
    connect(mapStateToProps, {
        toggleSidenav,
        toggleSidenavVariant,
        setSidenavOpen,
        patchOrganization: (org) => ({
            type: "CURRENT_ORGANIZATION",
            response: org,
            status: "success"
        })
    })
)(CompactLayout);
